// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vant from "../components/vant"
// 2. 引入组件样式
import 'vant/lib/index.css';
import { Dialog,Toast,ImagePreview } from 'vant';
import { vueBaberrage } from 'vue-baberrage'
import 'animate.css';
import Videojs from 'video.js'
import 'video.js/dist/video-js.css'
import { signature } from "@/api/common";
import wx from 'weixin-js-sdk'
import { info } from '@/api/common.js'
import VConsole from 'vconsole';
// const vConsole = new VConsole({ theme: 'dark' });
import './openApp'

// Toast(jhdVisible.tiString())


import store from './store'
Vue.prototype.$store = store
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(ImagePreview)
Vue.use(vueBaberrage)
Vue.use(vant)
Vue.config.productionTip = false
Vue.prototype.$dialog = Dialog
Vue.prototype.$imagePreview = ImagePreview
Vue.prototype.$video = Videojs

var isiOSApp = false;
var jhdVisible = false;

function init(){
  var u = navigator.userAgent;
  isiOSApp = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if(!isiOSApp){
  }
  let userAgent = navigator.userAgent;
  console.log(111111111)
  console.log(userAgent)
  if (userAgent.indexOf("JHDNews") > -1) {
    jhdVisible = true;
  } else {
    jhdVisible = false;
  }
}

init()
Vue.prototype.$jhdVisible = jhdVisible

var shareTitle = '';
var shareContent = '';
var shareImage = '';
var shareUrl = ''
Vue.prototype.$moment = moment;
Vue.prototype.$registerWX = (path,query)=>{
  let _url = location.href.split("#")[0] + '#'+path+'?';
  for (const propName of Object.keys(query)) {
    const value = query[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          let params = propName + '[' + key + ']';
          var subPart = encodeURIComponent(params) + "=";
          _url += subPart + encodeURIComponent(value[key]) + "&";
        }
      } else {
        _url += part + encodeURIComponent(value) + "&";
      }
    }
  }
  _url = _url.slice(0, -1);
  shareTitle = '红领巾 劳动吧';
  shareContent = '全国首个少先队员劳动教育实践网上平台';
  shareImage = 'https://jcdn.xhby.net/staticfile/images/jhdshare.jpg';
  shareUrl = _url
  let _this = this
  signature({ url: _url }).then(res => {
    const wxData = res.data;
    wx.config({
      debug: false,
      appId: wxData.appId,
      timestamp: wxData.timestamp,
      nonceStr: wxData.nonceStr,
      signature: wxData.signature,
      jsApiList: ["updateTimelineShareData", "updateAppMessageShareData",'chooseImage', 'previewImage'],
      openTagList: ["wx-open-launch-app"]
    });
    wx.ready(() => {
      let wxData = {
        title: '红领巾 劳动吧',
        desc: '全国首个少先队员劳动教育实践网上平台',
        link: _url,
        imgUrl: 'https://jcdn.xhby.net/staticfile/images/jhdshare.jpg',
        success: function () {
          console.log(11111)
          setTimeout(() => {
            console.log(2222)
            _this.initShareBtn()
          }, 1000);
        }
      };
      let pengyouquanData = {
        title: '红领巾 劳动吧',
        desc: '全国首个少先队员劳动教育实践网上平台',
        link: _url,
        imgUrl: 'https://jcdn.xhby.net/staticfile/images/jhdshare.jpg'
      };
      wx.updateAppMessageShareData(wxData);
      wx.updateTimelineShareData(pengyouquanData);
    });
  });
},

Vue.prototype.$registerWX2 = (path,query,_title,_desc)=>{
  let _url = location.href.split("#")[0] + '#'+path+'?';
  for (const propName of Object.keys(query)) {
    const value = query[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          let params = propName + '[' + key + ']';
          var subPart = encodeURIComponent(params) + "=";
          _url += subPart + encodeURIComponent(value[key]) + "&";
        }
      } else {
        _url += part + encodeURIComponent(value) + "&";
      }
    }
  }
  _url = _url.slice(0, -1);
  shareTitle = _title;
  shareContent = _desc;
  shareImage = 'https://jcdn.xhby.net/staticfile/images/jhdshare.jpg';
  shareUrl = _url
  let _this = this
  signature({ url: _url }).then(res => {
    const wxData = res.data;
    wx.config({
      debug: false,
      appId: wxData.appId,
      timestamp: wxData.timestamp,
      nonceStr: wxData.nonceStr,
      signature: wxData.signature,
      jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"],
      openTagList: ["wx-open-launch-app"]
    });
    wx.ready(() => {
      let wxData = {
        title: _title,
        desc: _desc,
        link: _url,
        imgUrl: 'https://jcdn.xhby.net/staticfile/images/jhdshare.jpg',
        success: function () {
          setTimeout(() => {
            _this.initShareBtn()
          }, 1000);
        }
      };
      let pengyouquanData = {
        title: _title,
        desc: _desc,
        link: _url,
        imgUrl: 'https://jcdn.xhby.net/staticfile/images/jhdshare.jpg'
      };
      wx.updateAppMessageShareData(wxData);
      wx.updateTimelineShareData(pengyouquanData);
    });
  });
},
Vue.prototype.$registerWX3 = (path,query,_title,_desc,_imgUrl)=>{
  let _url = location.href.split("#")[0] + '#'+path+'?';
  for (const propName of Object.keys(query)) {
    const value = query[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          let params = propName + '[' + key + ']';
          var subPart = encodeURIComponent(params) + "=";
          _url += subPart + encodeURIComponent(value[key]) + "&";
        }
      } else {
        _url += part + encodeURIComponent(value) + "&";
      }
    }
  }
  _url = _url.slice(0, -1);
  shareTitle = _title;
  shareContent = _desc;
  shareImage = _imgUrl;
  shareUrl = _url
  let _this = this
  signature({ url: _url }).then(res => {
    const wxData = res.data;
    wx.config({
      debug: false,
      appId: wxData.appId,
      timestamp: wxData.timestamp,
      nonceStr: wxData.nonceStr,
      signature: wxData.signature,
      jsApiList: ["updateTimelineShareData", "updateAppMessageShareData",'chooseImage', 'previewImage'],
      openTagList: ["wx-open-launch-app"]
    });
    wx.ready(() => {
      let wxData = {
        title: _title,
        desc: _desc,
        link: _url,
        imgUrl: _imgUrl,
        success: function () {
          setTimeout(() => {
            _this.initShareBtn()
          }, 1000);
        }
      };
      let pengyouquanData = {
        title: _title,
        desc: _desc,
        link: _url,
        imgUrl: _imgUrl
      };
      wx.updateAppMessageShareData(wxData);
      wx.updateTimelineShareData(pengyouquanData);
    });
  });
},
function initShareBtn(_this){
  try {
    const buttons = document.querySelectorAll('.launch-app-btn');
    console.log(buttons)
    buttons.forEach((btn) => {
      btn.addEventListener("click", function (e) {
      });
      btn.addEventListener("error", function (e) {
        window.location.href = 'type=encode&url='+btoa(window.location.href.split("#")[0]+'#'+this.$route.path+'?'+this.$getUrlParam(this.$route.query))
      });
    });
  } catch (error) {
    console.log(error)
  }
}
appShareInit()
var isiOS = false
function appShareInit(){
  window.getShareInfo = getShareInfo;
  var u = navigator.userAgent;
  isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  console.log(isiOS)
}
function getShareInfo(str){
  let shareObj = {
    title:shareTitle,
    content:shareContent,
    image:shareImage,
    url:shareUrl
  }
  console.log(shareObj)
  return shareObj
  // if(isiOS){
    // window.webkit.mes ssageHandlers.app_call.postMessage(JSON.stringify({type: 'doShare',data: shareObj}));
  // }else{
  //   return shareObj
  // }
}

window.appCallBackType = function (data) {
  // console.log("App CallBack Data:", data);
  // 兼容ios缺陷
  let _cookie = localStorage.getItem('cookie')
  if(!data&&_cookie){
    localStorage.clear()
    console.log(111)
    store.dispatch("setUserInfo", '')
    return
  }
  
  // console.log("App CallBack Data:", JSON.stringify(data));
  var value = JSON.parse(data);
  if(!value.hasOwnProperty('data')&&_cookie){
    localStorage.clear()
    store.dispatch("setUserInfo", '')
    return
  }
  if (value.type === "getUserInfo"||value.type === "getLocation"||value.type === "getUserInfoNoLogin") {
    console.log(value.data.token)
    localStorage.setItem('cookie',value.data.token)
    // console.log(value)
    // alert(value.data.token)
    info().then(res=>{
      if(res.status == 200){
        localStorage.setItem('loginInfo',JSON.stringify(res.data))
        store.dispatch("setUserInfo", res.data)
      }
    }).catch(err=>{
      console.log(err)
      // console.log(err)
    })

      // console.log("User Info:", value.data);
  }
}
Vue.prototype.$getUrlParam = (name)=>{
  let params = '';
  for (let key in name) {
    if (params !== '') {
      params += '&';
    }
    params += `${encodeURIComponent(key)}=${encodeURIComponent(name[key])}`;
  }
  return params
}
Vue.prototype.$isWeiXinFn = ()=> {
  var ua = window.navigator.userAgent.toLowerCase();
  console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
  } else {
      return false;
  }
}
Vue.prototype.$postMessageToApp = (message)=>{
  const ua = navigator.userAgent;
  if (ua.indexOf("JHDNews/HM") > -1) {
    // 鸿蒙设备
    app_call.postMessage(JSON.stringify(message));
  } else if (ua.match(/(iPhone|iPod|iPad);?/i)) {
    // iOS 设备
    window.webkit.messageHandlers.app_call.postMessage(
      JSON.stringify(message)
    );
  } else {
    if (message.type == "shareWithBase64Image") {
      window.app_call[message.type](message.pic);
      return;
    }
    // Android 设备
    window.app_call.postMessage(JSON.stringify(message));
  }
  // if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
  //   // iOS 设备
  //   window.webkit.messageHandlers.app_call.postMessage(JSON.stringify(message));
  // } else {
  //   // Android 设备
  //   window.app_call.postMessage(JSON.stringify(message));
  // }
}
// Vue.use(LottiePlayer);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js